import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from 'store/projectManagerList/projectManagerListTypes'
import API from 'store/projectManagerList/projectManagerListApis'


function* getAllProjectManagers({payload : payload}) {
  try {
    let response = yield call(API.getAllProjectManagers, payload)
   if ( response.status === 200 ) {
      yield put({type:'FETCH_ALL_PROJECT_MANAGERS_SUCCEEDED', payload: response.data});
    } else if (response.status === 401) {
        yield put({type:'UNAUTHORIZED'})
    } else {
        yield put({type: 'FETCH_ALL_PROJECT_MANAGERS_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again', className: 'copy-screeners-snackbar'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("Fetch all project managers request failed: ",err);
       yield put({type:'FETCH_ALL_PROJECT_MANAGERS_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again', className: 'copy-screeners-snackbar'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}
export default function* projectManagerListSaga () {
  yield takeLatest(types.FETCH_ALL_PROJECT_MANAGERS_REQUESTED, getAllProjectManagers)
}
